module.exports = __webpack_public_path__ + "img/success.d64df29d.jpg";